
const QUERY_PRESERVE_PARAMS = [
    "utm_campaign",
    "utm_term",
    "utm_content",
    "utm_medium",
    "utm_source",
    "category",
    "source",
    "orderId",
    "wOrderId",
    "appointmentId",
    "location",
    "garageId",
    'slot_type',
    "hide_app_bar",
    "pincode",
    "color"
  ];
  

  export const getUrlWithUtmParams = ({ url, queryParams }) => {
    const urlParams = new URLSearchParams(window.location.search);
  
    const apiUrl = new URL(`${window.location.origin}${url}`);
  
    Object.keys(queryParams)?.forEach(item => {
      const value = queryParams[item];
      if (value) apiUrl.searchParams.append(item, value);
    });
  
    QUERY_PRESERVE_PARAMS.forEach(item => {
      if (item === "lpSource") return;
      const value = urlParams.get(item);
      if (value) apiUrl.searchParams.append(item, value);
    });
  
    return apiUrl?.href;
  };

import Router from "next/router";

const f = action => (...params) => {
  let [options, path, ...args] = params;
  if (params.length === 1) {
    if (typeof params[0] === "string") {
      [path] = params;
      options = {
        pathname: path,
        query: {}
      };
      args = [];
    } else if (typeof params[0] === "object") {
      [options] = params;
      path = options.pathname;
      args = [];
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};
  const pathUrl = new URL(`http://dummydomain.com${path}`);
  Object.entries(options.query).forEach(([key, value]) => {
    if (pathUrl.searchParams.get(key) !== value) {
      pathUrl.searchParams.append(key, value);
    }
  });
  path = pathUrl.href.replace("http://dummydomain.com", "");

  QUERY_PRESERVE_PARAMS.forEach(item => {
    const value = urlParams.get(item);
    if (value) {
      if(!path.includes(item)) pathUrl.searchParams.append(item, value);
      utmParams[item] = value;
    }
    });
    path = pathUrl.href.replace("http://dummydomain.com", "");

    console.log({path})
  Router[action](path);
};

export default (() => ({
  push: f("push"),
  replace: f("replace")
}))();
